module.exports = __webpack_public_path__ + "static/iPad-f060bf1062d2baed5f65729c4dda9fe4.png";